// assets
import { AppstoreOutlined, FormOutlined, IdcardOutlined, ProfileOutlined, DollarOutlined, MessageOutlined } from '@ant-design/icons';

// icons
const icons = {
  AppstoreOutlined,
  FormOutlined,
  IdcardOutlined,
  ProfileOutlined,
  DollarOutlined,
  MessageOutlined
};

// ==============================|| MENU ITEMS - ADMINISTRATIVO ||============================== //

const support = {
  id: 'support',
  title: 'Administrativo',
  type: 'group',
  children: [
    {
      id: 'anamnesis',
      title: 'Anamnese',
      type: 'item',
      url: '/cadastros/anamnese',
      icon: icons.FormOutlined
    },
    {
      id: 'mensageria',
      title: 'MensagerIA',
      type: 'item',
      url: '/cadastros/mensageria',
      icon: icons.MessageOutlined
    },
    {
      id: 'plans',
      title: 'Pacotes',
      type: 'item',
      url: '/cadastros/planos',
      icon: icons.AppstoreOutlined
    },
    {
      id: 'pricing',
      title: 'Precificação',
      type: 'item',
      url: '/cadastros/precificacao',
      icon: icons.DollarOutlined
    },
    {
      id: 'procedures',
      title: 'Procedimentos',
      type: 'item',
      url: '/cadastros/procedimentos',
      icon: icons.ProfileOutlined
    },
    {
      id: 'professionals',
      title: 'Profissionais',
      type: 'item',
      url: '/cadastros/profissionais',
      icon: icons.IdcardOutlined
    }
  ]
};

export default support;
